import { connect } from 'react-redux'
import { setMapboxLoading } from 'Modules/app/actions'
import MapboxLoader from './MapboxLoader'


const mapStateToProps = state => ({
  isMapboxLoading: state.app.isMapboxLoading,
})

const actions = {
  setMapboxLoading,
}

export default connect(mapStateToProps, actions)(MapboxLoader)
